export default "__VITE_ASSET__gu6lCfDv__"